import { render, staticRenderFns } from "./ProfileUserComponent.vue?vue&type=template&id=28b20543&scoped=true"
import script from "./ProfileUserComponent.vue?vue&type=script&lang=js"
export * from "./ProfileUserComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileUserComponent.vue?vue&type=style&index=0&id=28b20543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b20543",
  null
  
)

export default component.exports